import { useTranslate } from "../../language/i18n";
import { Absence } from "../../services/absence/types";
import { getFullDate } from "../../utils/DateUtil";
import MessageBox, { Type as MessageBoxType } from "../shared/MessageBox/MessageBox";

interface Props {
  absence?: Absence | null;
  recipientName?: string;
}

const AbsenceBanner = ({ absence, recipientName }: Props) => {
  const translate = useTranslate();

  if (!absence?.startDate || !absence.endDate) return null;

  const text = translate("ABSENCE_BANNER", {
    name: recipientName,
    startDate: getFullDate(absence.startDate),
    endDate: getFullDate(absence.endDate),
  });

  return <MessageBox message={text} type={MessageBoxType.Warning} />;
};

export default AbsenceBanner;
